import React, { useEffect, useState } from 'react';
import API from '../../../utils/axiosInstance';
import '../../../assets/css/Sidebar.css';

const Roles = () => {
  const [roles, setRoles] = useState([]);
  const [formData, setFormData] = useState({ id: '', name: '' });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = () => {
    API.get('/v1/roles')
      .then((response) => {
        setRoles(response.data);
      })
      .catch((error) => {
        console.error('Error fetching roles:', error);
      });
  };

  const handleSaveRole = () => {
    if (!formData.name.trim()) return;

    if (formData.id) {
      // Update role
      API.patch(`/v1/roles/${formData.id}`, { name: formData.name.trim().toUpperCase() })
        .then(() => {
          fetchRoles();
          resetForm();
        })
        .catch((error) => console.error('Error updating role:', error));
    } else {
      // Add role
      API.post('/v1/roles', { name: formData.name.trim().toUpperCase() })
        .then(() => {
          fetchRoles();
          resetForm();
        })
        .catch((error) => console.error('Error adding role:', error));
    }
  };

  const handleDeleteRole = (id) => {
    API.delete(`/v1/roles/${id}`)
      .then(() => {
        fetchRoles();
      })
      .catch((error) => console.error('Error deleting role:', error));
  };

  const handleEditClick = (role) => {
    setFormData(role);
    setShowPopup(true);
  };

  const resetForm = () => {
    setFormData({ id: '', name: '' });
    setShowPopup(false);
  };

  return (
    <div className="roles-container">
      <h4 style={{ color: 'black' }}>Roles</h4>
      <button onClick={() => setShowPopup(true)} className="btn-color">
        <b>Add Role</b>
      </button>

      <div className="table-wrapper">
        <table className="staff-table">
          <thead className='tableborder'>
            <tr>
              <th>ID</th>
              <th>Role Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role) => (
              <tr key={role.id} className='datahover'>
                <td>{role.id}</td>
                <td>{role.name}</td>
                <td>
                  <button className="btn-color" onClick={() => handleEditClick(role)}>✏️</button>
                  {/* <button className="delete-btn" onClick={() => handleDeleteRole(role.id)}>🗑</button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>{formData.id ? 'Edit' : 'Add'} Role</h3>
            <input
              type="text"
              placeholder="Enter role name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <button onClick={handleSaveRole}>{formData.id ? 'Update' : 'Add'}</button>
            <button onClick={resetForm}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Roles;
